import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-8 p-ml-2" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "p-d-flex p-mb-1 p-mt-0" }, "Staff")
], -1)
const _hoisted_3 = { class: "p-d-flex p-col-4 p-mb-1 p-ai-center p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: _ctx.toCreatePerson(),
          class: "name p-col-9 p-text-right clickable",
          style: {"text-decoration":"none","color":"inherit"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "p-button-outlined",
              label: "Nuevo Staff"
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createVNode(_component_TabMenu, {
      model: _ctx.menuItems,
      onTabChange: _ctx.onTabChange
    }, null, 8, ["model", "onTabChange"]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { onOnTabChange: _ctx.onTabChange }, null, 8, ["onOnTabChange"]))
        ], 1024))
      ]),
      _: 1
    })
  ], 64))
}